import { deliverySaleShopifyStatusClass } from 'utils';
import { DELIVERY_SALE_SHOPIFY_STATUS } from 'utils/constants';
import Sale from './Sale';

class ShopifySale extends Sale {
  constructor(sale) {// eslint-disable-line
    super(sale);
  }
  getSaleClass() {
    return deliverySaleShopifyStatusClass(this.fulfillment_status);
  }
  getSaleStatus() {
    return DELIVERY_SALE_SHOPIFY_STATUS[this.fulfillment_status];
  }
  isReadyToDispatch() {
    return (
      this.destination?.lat === null ||
      this.destination?.address === null ||
      this.destination?.lon === null ||
      this.order?.city_id === null ||
      (![null, undefined].includes(this?.booking_id) && this.status_cd !== 102 && this.status_cd !== 100)
    );
  }
}

export default ShopifySale;
